import React from "react"

import Logo from "assets/img/bisu-logo-md.png"

const Header = ({ data, session }) => {
  return (
    <table className="print-title">
      <tbody>
        <tr>
          <td width="50">
            <img src={Logo} width="50" alt="BISU LOGO" className="logo" />
          </td>
          <td>
            Republic of the Philippines<br />
            <strong>BOHOL ISLAND STATE UNIVERSITY</strong>
            <br />
            <em>{session.get('campus')}</em>
            <br />
            {session.get('campus_address')}
          </td>
          <td width="200" className="text-right vbottom">
            <strong>Office of the Registrar</strong>
            <br />
            <small>
              <em>BISU {session.get('campus')}</em>
            </small>
          </td>
        </tr>
        <tr>
          <td className="text-center" colSpan="3">
            <div className="title">GRADING SHEET</div>
            SY: <strong>{data.get("sy")}</strong> , Term:{" "}
            <strong>{data.get("sem")}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/containers/Print/GradesSubmitted/header.js